import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import SecureStorage from "@gerenciatd/next13.utils.secure.local-storage";
import isWebview from "@gerenciatd/next13.utils.common.is-webview";
import { actions as mainActions } from "@/bit/reducers/next13.reducers.main-reducer";
import createContext from "./create-initial-object";
import getCookie from "@gerenciatd/next13.utils.common.get-cookie";
import getGeo from "./get-geo";
import getOptanonCookieInfo from "@gerenciatd/next13.utils.page.get-optanon-cookie-info";
import getEg from "./get-eg";
import getRecom from "./get-recom";


const getOptanonCookieInfoWebview = async () => {
  let optanon = getCookie("OptanonConsent");
  optanon = decodeURIComponent(optanon);
  let ad_storage = optanon && optanon.indexOf("C0004:1") !== -1 ? "granted" : "denied";
  let analytics_storage = optanon && optanon.indexOf("C0002:1") !== -1 ? "granted" : "denied";
  let ad_user_data = ad_storage;
  let ad_personalization = ad_storage;

  let retries = 10;
  let waitWB = setInterval(async () => {
    retries--;
    if (window.webviewBridge) {
      retries = -1;
      let status = await window.webviewBridge.getAttStatus();
      if (status != null) {
        ({ status } = status);
        // cogemos el valorcito, sino me quedo los que ya
        ad_storage = status;
        analytics_storage = status;
        ad_user_data = status;
        ad_personalization = status;
      }
    }
    if (retries < 0) {
      clearInterval(waitWB);
    }
  }, 100);

  return {
    ad_storage,
    analytics_storage,
    ad_user_data,
    ad_personalization,
  };
};


class RouteHandler extends Component {
  
  constructor(props){
    super(props);
    RouteHandler.__singletonRef = this;
  }

  static loadPage = () => {
    RouteHandler.__singletonRef.handleRouteLanding()
  }
  
  handleRouteLanding = async () => {
    const {
      context,
      checkCPAndSetZones,
      setCpParams,
      setUserPqInfo,
      setUserLgInfo,
      setUserRecom,
      setContextData,
      isReactApp,
    } = this.props;

    const secureStorage = new SecureStorage();
    const persistedInfo = secureStorage.getItem("ts");

    // 1) Miramos estado cookies
    let {
      ad_storage, 
      analytics_storage,
      ad_user_data,
      ad_personalization,
    } = {};
    
    if (isWebview()) {
      ({ 
        ad_storage,
        analytics_storage,
        ad_user_data,
        ad_personalization
      } = await getOptanonCookieInfoWebview());
    } else {
      ({ 
        ad_storage, 
        analytics_storage,
        ad_user_data,
        ad_personalization      
      } = getOptanonCookieInfo());
    }

    // 2) Creamos context para main en redux y enviamos a GA
    createContext({
      context,
      setUserPqInfo,
      setUserLgInfo,
      setContextData,
      ad_storage,
      analytics_storage,
      ad_user_data,
      ad_personalization,
      isReactApp
    });

    // 3) Persistimos geo
    getGeo({ persistedInfo, checkCPAndSetZones, setCpParams });

    // 4) Persistimos getRecom
    getRecom({ persistedInfo, setUserRecom, ad_storage, analytics_storage });

    // 5) Persistimos getEg
    getEg({ persistedInfo });

  };


  componentDidMount() {
    const { isReactApp } = this.props;
    if(!isReactApp){
      this.handleRouteLanding();
    }
  }

  render() {
    return <></>;
  }
}

RouteHandler.propTypes = {
  isReactApp: PropTypes.bool,
}

RouteHandler.defaultProps = {
  isReactApp: false,
}

const mapStateToProps = (state) => ({
  context: state.main.context,
});

const mapDispatchToProps = (dispatch) => ({
  setCpParams: (data) => dispatch(mainActions.setCpParams(data)),
  setContextData: (newData) => dispatch(mainActions.setContextData(newData)),
  checkCPAndSetZones: (data) => dispatch(mainActions.checkCPAndSetZones(data)),
  setUserPqInfo: (data) => dispatch(mainActions.setUserPqInfo(data)),
  setUserLgInfo: (data) => dispatch(mainActions.setUserLgInfo(data)),
  setUserRecom: (data) => dispatch(mainActions.setUserRecom(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RouteHandler);
